export default __webpack_public_path__ + "static/media/bear2.0fda4090.png";